import { lazy } from 'react';

const Dashboard = lazy(() => import('../pages/admin/dashboard/AdminDashboardPage.jsx'));
const Products = lazy(() => import('../pages/admin/products/AdminProductsPage.jsx'));
const AddProduct = lazy(() => import('../pages/admin/products/AddProductPage.jsx'));
const EditProduct = lazy(() => import('../pages/admin/products/EditProductPage.jsx'));
const ViewProduct = lazy(() => import('../pages/admin/products/ViewProductPage.jsx'));
const Categories = lazy(() => import('../pages/admin/Categories.jsx'));
const Brands = lazy(() => import('../pages/admin/brands/AdminBrandsPage.jsx'));
const Inventory = lazy(() => import('../pages/admin/inventory/InventoryPage.jsx'));
const LowStock = lazy(() => import('../pages/admin/inventory/LowStockPage.jsx'));
const OutOfStock = lazy(() => import('../pages/admin/inventory/OutOfStockPage.jsx'));
const InventoryMovements = lazy(() => import('../pages/admin/inventory/InventoryMovementsPage.jsx'));
const Orders = lazy(() => import('../pages/admin/orders/AdminOrdersPage.jsx'));
const OrderDetails = lazy(() => import('../pages/admin/orders/AdminOrderDetailsPage.jsx'));
const Inquiries = lazy(() => import('../pages/admin/inquiries/AdminInquiriesPage.jsx'));
const InquiryDetails = lazy(() => import('../pages/admin/inquiries/AdminInquiryDetailsPage.jsx'));
const Customers = lazy(() => import('../pages/admin/customers/AdminCustomersPage.jsx'));
const CustomerDetails = lazy(() => import('../pages/admin/customers/AdminCustomerDetailsPage.jsx'));
const Banners = lazy(() => import('../pages/admin/banners/AdminBannersPage.jsx'));
const AddBanner = lazy(() => import('../pages/admin/banners/AddBannerPage.jsx'));
const EditBanner = lazy(() => import('../pages/admin/banners/EditBannerPage.jsx'));
const Ads = lazy(() => import('../pages/admin/ads/AdminAdsPage.jsx'));
const AddAd = lazy(() => import('../pages/admin/ads/AddAdPage.jsx'));
const EditAd = lazy(() => import('../pages/admin/ads/EditAdPage.jsx'));
const Blog = lazy(() => import('../pages/admin/blog/AdminBlogPage.jsx'));
const AddBlog = lazy(() => import('../pages/admin/blog/AddBlogPage.jsx'));
const EditBlog = lazy(() => import('../pages/admin/blog/EditBlogPage.jsx'));
const BlogPreview = lazy(() => import('../pages/admin/blog/BlogPreviewPage.jsx'));
const BlogCategories = lazy(() => import('../pages/admin/blog/BlogCategoriesPage.jsx'));
const BlogTags = lazy(() => import('../pages/admin/blog/BlogTagsPage.jsx'));
const Reports = lazy(() => import('../pages/admin/reports/AdminReportsPage.jsx'));
const SeoSettings = lazy(() => import('../pages/admin/seo/AdminSeoPage.jsx'));
const UsersRoles = lazy(() => import('../pages/admin/users/AdminUsersPage.jsx'));
const AddUser = lazy(() => import('../pages/admin/users/AddUserPage.jsx'));
const EditUser = lazy(() => import('../pages/admin/users/EditUserPage.jsx'));
const UserDetails = lazy(() => import('../pages/admin/users/AdminUserDetailsPage.jsx'));
const WebsiteSettings = lazy(() => import('../pages/admin/settings/AdminSettingsPage.jsx'));
const ActivityLogs = lazy(() => import('../pages/admin/activity-logs/AdminActivityLogsPage.jsx'));

const adminRoutes = [
  { path: '', Component: Dashboard },
  { path: 'dashboard', Component: Dashboard },
  { path: 'products', Component: Products },
  { path: 'products/add', Component: AddProduct },
  { path: 'products/new', Component: AddProduct },
  { path: 'products/edit/:id', Component: EditProduct },
  { path: 'products/:id/edit', Component: EditProduct },
  { path: 'products/:id', Component: ViewProduct },
  { path: 'categories', Component: Categories },
  { path: 'brands', Component: Brands },
  { path: 'inventory', Component: Inventory },
  { path: 'inventory/low-stock', Component: LowStock },
  { path: 'inventory/out-of-stock', Component: OutOfStock },
  { path: 'inventory/movements', Component: InventoryMovements },
  { path: 'orders', Component: Orders },
  { path: 'orders/:id', Component: OrderDetails },
  { path: 'inquiries', Component: Inquiries },
  { path: 'inquiries/:id', Component: InquiryDetails },
  { path: 'customers', Component: Customers },
  { path: 'customers/:id', Component: CustomerDetails },
  { path: 'banners', Component: Banners },
  { path: 'banners/add', Component: AddBanner },
  { path: 'banners/edit/:id', Component: EditBanner },
  { path: 'ads', Component: Ads },
  { path: 'ads/add', Component: AddAd },
  { path: 'ads/edit/:id', Component: EditAd },
  { path: 'blog', Component: Blog },
  { path: 'blog/add', Component: AddBlog },
  { path: 'blog/edit/:id', Component: EditBlog },
  { path: 'blog/preview/:id', Component: BlogPreview },
  { path: 'blog/categories', Component: BlogCategories },
  { path: 'blog/tags', Component: BlogTags },
  { path: 'reports', Component: Reports },
  { path: 'seo', Component: SeoSettings },
  { path: 'users', Component: UsersRoles },
  { path: 'users/add', Component: AddUser },
  { path: 'users/edit/:id', Component: EditUser },
  { path: 'users/:id', Component: UserDetails },
  { path: 'settings', Component: WebsiteSettings },
  { path: 'activity-logs', Component: ActivityLogs },
];

export default adminRoutes;
